import PropTypes from 'prop-types';

import TextField from 'components/Fields/TextField/TextField';
import SelectField from 'components/Fields/SelectField/SelectField';
import {
  withFullTranslationKey,
  CLAIM_DETAILS,
  OPTIONS_TRADEMARK_STATUS_LIST,
} from 'components/ContentReporting/ContentLegalReporting/content-legal-reporting-config';
import { USE_LABEL_FROM_TRANSLATION_PREFIX } from 'components/ContentReporting/shared-constants';

const getFieldValue = data => identifier => data && data[identifier] ? data[identifier].value : '';
const getFieldValidValue = data => identifier => data && data[identifier] ? data[identifier].valid : true;

const TrademarkContentTypeFields = ({ formData, handleFieldChange, forceValidation, t }) => {
  const fieldValue = getFieldValue(formData);
  const fieldValidValue = getFieldValidValue(formData);

  return (
    <>
      <TextField
        field={{
          name: CLAIM_DETAILS.fields.CLAIM_TRADEMARK_NAME,
          type: 'text',
          maxlength: 50,
          labelOverride: t(CLAIM_DETAILS.labels.CLAIM_TRADEMARK_NAME),
          required: true,
        }}
        value={fieldValue(CLAIM_DETAILS.fields.CLAIM_TRADEMARK_NAME)}
        onFieldChange={handleFieldChange}
      />
      <SelectField
        field={{
          name: CLAIM_DETAILS.fields.CLAIM_TRADEMARK_STATUS,
          type: 'text',
          options: OPTIONS_TRADEMARK_STATUS_LIST,
          required: true,
          labelOverride: USE_LABEL_FROM_TRANSLATION_PREFIX,
        }}
        hasDefaultPlaceholder
        value={fieldValue(CLAIM_DETAILS.fields.CLAIM_TRADEMARK_STATUS)}
        valid={fieldValidValue(CLAIM_DETAILS.fields.CLAIM_TRADEMARK_STATUS)}
        tPrefix={withFullTranslationKey(CLAIM_DETAILS.translationPrefixes.CLAIM_TRADEMARK_STATUS)}
        onFieldChange={handleFieldChange}
        forceValidation={forceValidation}
      />

      <TextField
        field={{
          name: CLAIM_DETAILS.fields.CLAIM_TRADEMARK_NO,
          type: 'text',
          maxlength: 64,
          labelOverride: t(CLAIM_DETAILS.labels.CLAIM_TRADEMARK_NO),
        }}
        value={fieldValue(CLAIM_DETAILS.fields.CLAIM_TRADEMARK_NO)}
        onFieldChange={handleFieldChange}
      />
    </>
  );
};

TrademarkContentTypeFields.propTypes = {
  formData: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
  forceValidation: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

export default TrademarkContentTypeFields;
